import React from 'react'

import Card from './Card';


import Banner1 from './Banner1';


function Home() {
  return (
    <>
     
        <Banner1/>
        <Card />
        
     
    </>

  )
}

export default Home

